/** Guest mobile numbers are exactly 8 digits; these helpers convert between input digits and the stored number. */
export const MU_LOCAL_DIGITS = 8;

/** Keep only digits, capped at the 8 the user is allowed to type. */
export function sanitizeMuLocal(value) {
  return (value || '').replace(/\D/g, '').slice(0, MU_LOCAL_DIGITS);
}

/** Typed digits → the number sent to the API ('' stays ''). */
export function toMuPhone(local) {
  return sanitizeMuLocal(local);
}

/** Stored number (possibly with +230 etc.) → the 8 digits shown in inputs. */
export function fromMuPhone(phone) {
  let digits = (phone || '').replace(/\D/g, '');
  if (digits.startsWith('230') && digits.length > 8) digits = digits.slice(3);
  return digits.slice(0, MU_LOCAL_DIGITS);
}

/** True when all 8 digits have been typed. */
export function isCompleteMuLocal(local) {
  return sanitizeMuLocal(local).length === MU_LOCAL_DIGITS;
}
